import {
    Component,
    ComponentRef,
    effect,
    EventEmitter,
    inject,
    input,
    Output,
    untracked,
    ViewChild,
} from '@angular/core';
import { StepHostDirective } from '../../../shared/directives/step-host.directive';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models/order-state.model';
import { setComponentProps } from '@co-3/ctrl-ui/common';
import { ProductsService } from 'app/products/products.service';

@Component({
    selector: 'app-landing-page-container',
    template: '<ng-container appStepHost></ng-container>',
    standalone: false,
})
export class LandingPageContainerComponent {
    private productService = inject(ProductsService);
    private baseProduct = this.productService.baseProduct;
    private product = this.productService.product;

    public state = input<OrderState>();

    @Output()
    public next: EventEmitter<Partial<OrderState>> = new EventEmitter<Partial<OrderState>>();

    @ViewChild(StepHostDirective, { static: true })
    public stepHost!: StepHostDirective;

    private componentRef: ComponentRef<OrderStepBaseComponent> | undefined;

    public constructor() {
        // Reset the landing page component, when the base product changes
        effect(() => {
            const baseProduct = this.baseProduct();
            if (!baseProduct) {
                return;
            }

            untracked(() => {
                this.stepHost.viewContainerRef.clear();
                this.componentRef = this.stepHost.viewContainerRef.createComponent<OrderStepBaseComponent>(
                    this.product().orderConfig.steps[0].component,
                );
                this.componentRef.instance.next.subscribe((data) => this.next.emit(data));
                setComponentProps(this.componentRef, { state: this.state() });
            });
        });
    }
}
